<template lang="">
    <div id="content">
      <div class="global_area">
        <div class="path"><a href="#none">Home</a> &gt; <a href="#none">캠페인 관리</a> &gt; <strong>캠페인 리스트</strong></div>
        <h2 class="h_sub">캠페인 리스트</h2>
      </div>
      
      <CampaignManageListForm/>
    </div>
  </template>
  
  <script>
  import CampaignManageListForm from '@/components/admin/product/CampaignManageListForm.vue';
  
  export default {
    components: {
        CampaignManageListForm
    }
  }
  </script>
  <style lang="">
      
  </style>